module.exports = __webpack_public_path__ + "static/media/draw.605a8bf9.png";